import React from 'react'
import UniversityLogo from '../UniversityLogo'
import styled from 'styled-components'

const StComplexItem = styled.div`
  border-bottom: 1px solid #ccc;
  position: relative;
  display: grid;
  grid-template-columns: 80px 1fr;
  overflow: visible;
  margin-bottom: 0.8rem;
  padding-bottom: 1rem;

  .number {
    font-size: 14rem;
    font-weight: bold;
    line-height: 0.75;
    -webkit-text-stroke: 3px #f2473e;
    text-stroke: 3px #f2473e;
    color: #efefef;
    user-select: none;
    letter-spacing: -1rem;
  }
  .title {
  }
  .logo {
    margin-left: 30px;
    filter: grayscale(100);
  }
  &.smaller {
    grid-template-columns: 40px 1fr;
    .logo {
      margin-left: 15px;
    }
    .number {
      font-size: 10rem;
    }
    .un-title {
      font-size: 1.6rem;
    }
  }
  @media (orientation: portrait) {
    grid-template-columns: 40px 1fr;
    .logo {
      margin-left: 15px;
    }
    .number {
      font-size: 10rem;
    }
    .un-title {
      font-size: 1.6rem;
    }
  }
`

const SimpleItem = data => {
  const { name, abbr } = data
  return (
    <div>
      <h2>{name}</h2>
    </div>
  )
}

const ComplexItem = (data, position, className) => {
  const { name, abbr, logo, numeroDuro } = data
  return (
    <StComplexItem className={className}>
      <div>
        <h4 className="number">{numeroDuro ? numeroDuro : position}</h4>
      </div>
      <div>
        <UniversityLogo className="w-20 h-32 logo " university={logo} />
        <h2 className="font-bold leading-none un-title">{name}</h2>
      </div>
    </StComplexItem>
  )
}

const RankingItem = ({ complex = false, data, position, className = '' }) => {
  if (complex) {
    return ComplexItem(data, position, className)
  }
  return SimpleItem(data, position)
}

export default RankingItem
